module.exports = __webpack_public_path__ + "static/media/Screen Shot 2019-06-18 at 2.45.03 PM.9cc2c2b7.png";